var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEkisLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114 128",
    id: "vector",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M 54.1 94.5 L 26.4 125.4 C 23.1 129.1 17.2 128.8 14.3 124.7 L 2.1 107.4 C 0.1 104.6 0.2 100.8 2.4 98.1 L 16.2 80.7 C 18.4 77.9 18.4 73.9 16.2 71.1 L 2.3 53.6 C 0.2 50.9 0.1 47.1 2 44.3 L 14.3 27 C 17.2 22.9 23.1 22.6 26.4 26.3 L 43.4 45.3 L 32.7 58.4 C 30.4 61.2 30.4 65.3 32.7 68.2 L 54.1 94.5 Z",
    fill: "#00e6f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path_1",
    d: "M 88 68.6 L 111.2 93.6 C 114.1 96.7 114 101.2 110.8 104.6 C 107.6 107.9 90.3 125.9 90.3 125.9 C 87 128.9 81.9 128.6 79 125.1 L 54.1 94.5 L 66.2 81.1 C 68.8 78.2 68.8 73.7 66.2 70.7 L 43.4 45.3 L 77.9 2.9 C 80.7 -0.6 85.9 -0.9 89.2 2.1 L 110.8 22.1 C 113.9 25 114.1 29.9 111.2 33.1 L 88 58 C 85.3 61 85.3 65.6 88 68.6 Z",
    fill: "#893eff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path_2",
    d: "M 66.2 81 L 54.1 94.4 L 32.7 68.1 C 30.4 65.3 30.4 61.2 32.7 58.3 L 43.4 45.2 L 66.2 70.6 C 68.8 73.6 68.8 78.1 66.2 81 Z",
    fill: "#2f3ead"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEkisLogo);
export default __webpack_public_path__ + "static/media/ekis_logo.1ae3b1330aa1225064d1c39c5abb65bb.svg";
export { ForwardRef as ReactComponent };